<template>
  <transition name="fade">
    <div
      class="app-status-update__container"
      :class="type"
      @keydown.esc="closeOnEsc"
      @click="closeOnClickOff"
      v-show="data"
      tabindex="-1"
    >
      <transition name="appear" mode="out-in">
        <div
          v-if="data"
          ref="updateModal"
          class="app-status-update__modal"
          :class="[{ hasIcon: icon }, type]"
          :id="id"
          @click.stop
        >
          <div v-show="type === 'update'" class="app-status-update__close-button" @click="selfDestruct">
            <img src="@/assets/global-icons/cross-white-circle.svg" alt="" />
          </div>
          <div class="message">
            <img v-if="icon" :src="icon" :class="{ broadcast: data.icon === 'broadcast' }" />
            <span v-html="message" class="msg-title"></span>
            <span v-html="description" class="msg-desc" v-if="description"></span>
          </div>
          <div v-if="buttons" class="app-status-update__buttons">
            <app-status-button
              v-for="button in buttons"
              :key="button.id"
              :data="button"
              :confirmOrCancel="confirmOrCancel"
            />
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import AppStatusButton from '@/components/modals/status_update/AppStatusUpdateButton.vue';

import { mapGetters, mapActions } from 'vuex';

const iconMap = {
  // icon types
  error: 'global-icons/warning.svg',
  success: 'global-icons/success.png',
  broadcast: 'notification-icons/broadcast.svg',

  // popup types
  confirm: 'sidebar-icons/info.svg',
  announcement: 'notification-icons/announcement.png',
  processing: 'sidebar-icons/info.svg'
};

export default {
  name: 'AppStatusUpdate',
  components: {
    AppStatusButton
  },
  props: {
    data: Object
  },
  data() {
    return {
      timeoutFunc: null,
      defaultButtons: [
        {
          name: 'Okay',
          id: 'okay',
          background: 'var(--active-user-room)',
          textColour: 'white',
          function: 'close'
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      openMenu: 'root/isMenuOpen'
    }),
    // TO REDO: hacky way to check if the action is to enter a space.
    // checks for message content if it includes the word offline
    id() {
      let id = this.data.id;
      if (id) {
        return id;
      } else {
        return '';
      }
    },
    type() {
      return this.data?.type || 'update';
    },
    icon() {
      let iconType = this.data.icon;

      if (iconType === null || (!iconMap[iconType] && !iconMap[this.type])) return '';

      return require(`@/assets/${iconType !== undefined ? iconMap[iconType] : iconMap[this.type]}`);
    },
    message() {
      let message = this.data.message;
      if (message) {
        return message;
      } else {
        return '';
      }
    },
    description() {
      let description = this.data.description;
      if (description) {
        return description;
      } else {
        return false;
      }
    },
    timeout() {
      let timeout = 5000;
      if (this.data.timeout) {
        timeout = this.data.timeout;
      }
      return timeout;
    },
    buttons() {
      return this.type === 'confirm' ? this.data.buttons || this.defaultButtons : null;
    }
  },
  methods: {
    ...mapActions(['popups/close']),
    selfDestruct() {
      //slight delay so that checking if popup is open when handling click off sidebar can register properly
      let timeout = setTimeout(() => {
        this['popups/close']();
        clearTimeout(timeout);
      }, 50);
    },
    confirmOrCancel(event) {
      let type = event.target.dataset.id;
      let buttonData;
      this.buttons.forEach((button) => {
        if (button.id === type) {
          buttonData = button;
        }
      });
      if (buttonData) {
        let callback = buttonData.function;
        if (callback && callback !== 'close') {
          callback(event);
        }
        this.selfDestruct();
      }
    },
    closeOnEsc() {
      this.selfDestruct();
    },
    closeOnClickOff() {
      //don't allow confirm popups to close
      if (this.type === 'confirm') return;
      this.selfDestruct();
    },
    focusModal() {
      this.$nextTick(() => this.$refs.updateModal.focus());
    },
    onNewPopup() {
      if (this.type === 'update') {
        clearTimeout(this.timeoutFunc);
        this.timeoutFunc = setTimeout(this.selfDestruct, this.timeout);
      }
      if (this.type === 'confirm') {
        clearTimeout(this.timeoutFunc);
      }

      this.focusModal();
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(newData, oldData) {
        if (newData !== oldData && newData) {
          this.onNewPopup();
        }
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeoutFunc);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '~@/scss/components/modals/app_status_update_popup.scss';

@include mobile-only {
  ::v-deep .btn {
    width: 100%;
  }
}
</style>
